module.exports = __webpack_public_path__ + "img/pantalla-9-4.b47b647b.png";